import { get } from "lodash";

export default function lang(name, prepend) {
    if (prepend)
        name = `${prepend}.${name}`;

    const translated = get(Config.lang, name);

    if (translated)
        return translated;

    const translatedFallback = get(Config.lang_fallback, name)

    if (translatedFallback)
        return translatedFallback;

    console.warn('No translation for', name);

    return name;
}
